import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Button, Edit01 } from '@opendate-app/setlist';
import darkSelectStyles from '../../../shared/darkSelectStyles';
import '../styles/eventTemplatesManager.css';

const cardStyle = {
  background: 'var(--sl-bg-primary)',
  border: '1px solid var(--sl-border-secondary)',
  borderRadius: 'var(--radius-xl)',
  boxShadow: 'var(--sl-shadow-xs)',
};

const TemplateSummaryCard = ({
  label, options, value, onChange, usedByCount, summaryRows, loading, error, onEdit, editLabel, notice,
}) => (
  <div className="card h-100" style={cardStyle}>
    <div className="card-body">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="text-uppercase" style={{ fontSize: '12px', color: 'var(--sl-text-tertiary)' }}>{label}</span>
        {typeof usedByCount === 'number' ? (
          <span className="small" style={{ color: 'var(--sl-text-tertiary)' }}>
            {`Used by ${usedByCount} event template${usedByCount === 1 ? '' : 's'}`}
          </span>
        ) : null}
      </div>

      <Select
        classNamePrefix="template-picker"
        aria-label={label}
        styles={darkSelectStyles}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        isClearable
        placeholder="None"
        options={options}
        value={options.find((o) => String(o.value) === String(value)) || null}
        onChange={(option) => onChange(option ? option.value : null)}
      />

      {value !== null && value !== undefined && value !== '' ? (
        <div className="mt-3">
          {loading ? <div className="small" style={{ color: 'var(--sl-text-tertiary)' }}>Loading…</div> : null}
          {error ? <div className="small" style={{ color: 'var(--sl-text-tertiary)' }}>Couldn&apos;t load summary</div> : null}
          {!loading && !error ? summaryRows.map((row) => (
            <div key={row.label} className="d-flex justify-content-between small py-1">
              <span style={{ color: 'var(--sl-text-tertiary)' }}>{row.label}</span>
              <span className="font-weight-bold text-right" style={{ color: 'var(--sl-text-primary)' }}>{row.value}</span>
            </div>
          )) : null}
          {notice ? <div className="small mt-3 template-summary-card-notice">{notice}</div> : null}
          {onEdit ? (
            <div className="mt-3">
              <Button variant="secondary" icon={Edit01} onClick={onEdit}>{editLabel}</Button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  </div>
);

TemplateSummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
  })).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  usedByCount: PropTypes.number,
  summaryRows: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  editLabel: PropTypes.string.isRequired,
  notice: PropTypes.string,
};

export default TemplateSummaryCard;
